/* eslint-disable no-use-before-define */
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";

// pages grand public
import PageLogin from "./pages/public/PageLogin";
import PageChoixInstance from "./pages/public/PageChoixInstance";
import PageHome from "./pages/public/PageHome";
import PageIngovernance from "./pages/public/PageIngovernance";
import PageInsocial from "./pages/public/PageInsocial";
import PageInoperation from "./pages/public/PageInoperation";
import PageInviews from "./pages/public/PageInviews";
import PageCartoProcess from "./pages/public/PageCartoProcess";
import PageViewProcess from "./pages/public/PageViewProcess";
import PageEspaces from "./pages/public/PageEspaces";
import PageNotifications from "./pages/public/PageNotifications";
import PageFlashCode from "./pages/public/PageFlashCode";
import PageOrgunit from "./pages/public/PageOrgunit";
import PageEngagement from "./pages/public/PageEngagement";
import PageConfidentialite from "./pages/public/PageConfidentialite";

// page administration
import PageAdminEspacesColideeToCategorie from "./pages/admin/PageAdminEspacesColideeToCategorie";
import PageAdminOrgunits from "./pages/admin/PageAdminOrgunits.js";
import PageAdminEngagements from "./pages/admin/PageAdminEngagements.js";
import PageAdminPersonnes from "./pages/admin/PageAdminPersonnes";
import PageAdminCreatePersonne from "./pages/admin/personne/PageAdminCreatePersonne";
import PageAdminUpdatePersonne from "./pages/admin/personne/PageAdminUpdatePersonne";
import PageAdminLocalisations from "./pages/admin/PageAdminLocalisations";
import PageAdminMarques from "./pages/admin/PageAdminMarques";
import PageAdminDroitsAdministration from "./pages/admin/PageAdminDroitsAdministration.js";
import PageAdminDroitsConsultation from "./pages/admin/PageAdminDroitsConsultation.js";
import PageAdminInstance from "./pages/admin/PageAdminInstance.js";
import PageAdminEmission from "./pages/admin/PageAdminEmission.js";
import PageAdminPublication from "./pages/admin/PageAdminPublication.js";
import PageAdminStyle from "./pages/admin/PageAdminStyle.js";
import PageAdminProcesses from "./pages/admin/PageAdminProcesses";
import PageAdminSousMenus from "./pages/admin/PageAdminSousMenus.js";
import PageAdminVisualManagement from "./pages/admin/PageAdminVisualManagement.js";
import PageAdminAlaUne from "./pages/admin/PageAdminAlaUne.js";
import PageAdminEditView from "./pages/admin/PageAdminEditView";
import PageAdminStatistiques from "./pages/admin/PageAdminStatistiques";
import PageAdminUsages from "./pages/admin/PageAdminUsages";
import PageAdminPinnedOrgunits from "./pages/admin/PageAdminPinnedOrgunits";
import PageAdminNotifications from "./pages/admin/PageAdminNotifications";

// import PageAdminOffre from "./pages/admin/PageAdminOffre.js";

import { apiVerifTokenColidee } from "./api/ApiAuthentification";
import { apiUpdateUserByIdColidee } from "./api/ApiUser";
import { chgToken } from "./redux/ReduxToken";
import {
  chgEmail,
  chgPassword,
  chgNom,
  chgPrenom,
  chgPicture,
  chgIdColidee,
} from "./redux/ReduxUser";
import ComponentLoader from "./components/layout/ComponentLoader";
import ComponentTracking from "./components/layout/ComponentTracking";
import ComponentFastSwitchInstance from "./components/layout/ComponentFastSwitchInstance";
import { apiGetInstance } from "./api/ApiInstance";
import { chgInstance } from "./redux/ReduxInstance";
import ComponentTixme from "./components/layout/ComponentTixme";
import { PageRegister } from "./pages/public/PageRegister";

const App = () => {
  const dispatch = useDispatch();
  const [loadingGeneral, setLoadingGeneral] = useState(true);
  const [traceurNavigation, setTraceurNavigation] = useState(0);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);

  const verifAuthenticated = async () => {
    const tokenSauvegarde = localStorage.getItem("token");
    if (tokenSauvegarde) {
      const res = await apiVerifTokenColidee(tokenSauvegarde);

      if (!res.status || res.status === 403 || res.status === 500) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        localStorage.setItem("token", res.data.token);

        /* Mise à jour du token dans le REDUX pour s'en servir lors des requetes colidée */
        dispatch(chgToken(res.data.token));

        /* on va regarder si le gars a un deviceToken afin de le mettre dans la collection user */
        const deviceTokenSauvegarde = localStorage.getItem("deviceToken");
        if (deviceTokenSauvegarde) {
          res.data.deviceToken = deviceTokenSauvegarde;
        }

        // Mise a jour de la table user mongoDB
        await apiUpdateUserByIdColidee(res.data.id, res.data);
        dispatch(chgEmail(res.data.email));
        dispatch(chgNom(res.data.nom));
        dispatch(chgPrenom(res.data.prenom));
        dispatch(chgPicture(res.data.profile_pic));
        dispatch(chgIdColidee(res.data.id));
        // on met le password à null pour ne ps qu'il appraissen en clair dans le store
        dispatch(chgPassword(null));

        /* on va réhydrater l'instance pour d'eventuels changements (sous menus etc ...)   */
        if (ReduxInstance._id && ReduxUserEmail) {
          const instance = await apiGetInstance(ReduxInstance._id, ReduxUserEmail);
          if (instance.data) {
            dispatch(chgInstance(instance.data));
          }
        }

        /* on fait passer la personne sur la page choixInstance avec d'éventuels parametres dans l'URL */
        if (window.location.pathname === "/") {
          window.location.replace("/choixInstance" + window.location.search);
        } else {
          setLoadingGeneral(false);
        }
      }
    } else {
      setLoadingGeneral(false);
    }
  };

  /* renvoi un nombre entre 1000 et 10000 */
  const getRandomInt = () => {
    let min = Math.ceil(1000);
    let max = Math.floor(10000);
    return Math.floor(Math.random() * (max - min)) + min;
  };

  useEffect(() => {
    setTraceurNavigation(getRandomInt());
    verifAuthenticated();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {loadingGeneral && (
        <div className="d-flex h-100 justify-content-center align-items-center">
          <ComponentLoader />
        </div>
      )}
      {!loadingGeneral && (
        <BrowserRouter>
          <Routes>
            {/* routes publiques */}
            <Route exact path="/" element={<PageLogin />} />
            <Route exact path="/politique-confidentialite" element={<PageConfidentialite />} />
            <Route exact path="/createAccount" element={<PageRegister />} />
            <Route
              exact
              path="/choixInstance"
              element={
                <PrivateRouteIsLog>
                  <PageChoixInstance />
                </PrivateRouteIsLog>
              }
            />
            <Route
              exact
              path="/home"
              element={
                <PrivateRouteIsLogAndInstance>
                  <ComponentTracking
                    trackingTitle="A la une"
                    traceurNavigation={traceurNavigation}
                  />
                  <ComponentFastSwitchInstance />
                  <ComponentTixme fichierEtapes={ReduxInstance.tixme} pageConsultee="home" />
                  <PageHome />
                </PrivateRouteIsLogAndInstance>
              }
            />
            <Route
              exact
              path="/ingovernance"
              element={
                <PrivateRouteIsLogAndInstance>
                  <ComponentTracking
                    trackingTitle="Performance"
                    traceurNavigation={traceurNavigation}
                  />
                  <ComponentFastSwitchInstance />
                  <ComponentTixme
                    fichierEtapes={ReduxInstance.tixme}
                    pageConsultee="ingovernance"
                  />
                  <PageIngovernance />
                </PrivateRouteIsLogAndInstance>
              }
            />
            <Route
              exact
              path="/insocial"
              element={
                <PrivateRouteIsLogAndInstance>
                  <ComponentTracking
                    trackingTitle="Contributions"
                    traceurNavigation={traceurNavigation}
                  />
                  <ComponentFastSwitchInstance />
                  <ComponentTixme fichierEtapes={ReduxInstance.tixme} pageConsultee="insocial" />
                  <PageInsocial />
                </PrivateRouteIsLogAndInstance>
              }
            />
            <Route
              exact
              path="/inoperation"
              element={
                <PrivateRouteIsLogAndInstance>
                  <ComponentTracking
                    trackingTitle="Missions"
                    traceurNavigation={traceurNavigation}
                  />
                  <ComponentFastSwitchInstance />
                  <PageInoperation />
                </PrivateRouteIsLogAndInstance>
              }
            />
            <Route
              exact
              path="/inviews"
              element={
                <PrivateRouteIsLogAndInstance>
                  <ComponentTracking
                    trackingTitle="Inspiration"
                    traceurNavigation={traceurNavigation}
                  />
                  <ComponentFastSwitchInstance />
                  <PageInviews />
                </PrivateRouteIsLogAndInstance>
              }
            />
            <Route
              exact
              path="/orgunits/:id"
              element={
                <PrivateRouteIsLogAndInstance>
                  <ComponentTracking
                    trackingTitle="Détails OrgUnit"
                    traceurNavigation={traceurNavigation}
                  />
                  <PageOrgunit />
                </PrivateRouteIsLogAndInstance>
              }
            />
            <Route
              exact
              path="/engagements/:id"
              element={
                <PrivateRouteIsLogAndInstance>
                  <ComponentTracking
                    trackingTitle="Détails Engagement"
                    traceurNavigation={traceurNavigation}
                  />
                  <PageEngagement />
                </PrivateRouteIsLogAndInstance>
              }
            />
            <Route
              exact
              path="/cartographie-processus"
              element={
                <PrivateRouteIsLogAndInstance>
                  <ComponentTracking
                    trackingTitle="cartographie process"
                    traceurNavigation={traceurNavigation}
                  />
                  <ComponentFastSwitchInstance />
                  <PageCartoProcess />
                </PrivateRouteIsLogAndInstance>
              }
            />
            <Route
              exact
              path="/processes/:id"
              element={
                <PrivateRouteIsLogAndInstance>
                  <ComponentTracking
                    trackingTitle="Détails process"
                    traceurNavigation={traceurNavigation}
                  />
                  <PageViewProcess />
                </PrivateRouteIsLogAndInstance>
              }
            />
            <Route
              exact
              path="/espaces"
              element={
                <PrivateRouteIsLogAndInstance>
                  <ComponentTracking trackingTitle="Usages" traceurNavigation={traceurNavigation} />
                  <ComponentFastSwitchInstance />
                  <PageEspaces />
                </PrivateRouteIsLogAndInstance>
              }
            />

            <Route
              exact
              path="/notifications"
              element={
                <PrivateRouteIsLogAndInstance>
                  <ComponentTracking
                    trackingTitle="Paramétrage notifications"
                    traceurNavigation={traceurNavigation}
                  />
                  <PageNotifications />
                </PrivateRouteIsLogAndInstance>
              }
            />
            <Route
              exact
              path="/flashcodeVerif"
              element={
                <PrivateRouteIsLogAndInstance>
                  <ComponentTracking
                    trackingTitle="Flash Code vérification"
                    traceurNavigation={traceurNavigation}
                  />
                  <PageFlashCode />
                </PrivateRouteIsLogAndInstance>
              }
            />
            {/* routes admin */}
            {/* routes admin COLIDEE */}
            <Route
              exact
              path="/admin/colidee/espaces-colidee-to-categorie"
              element={
                <PrivateRouteIsAdminColidee>
                  <PageAdminEspacesColideeToCategorie />
                </PrivateRouteIsAdminColidee>
              }
            />
            {/* routes admin SOUSCRIPTEUR> */}
            <Route
              exact
              path="/admin/easygouv/instance"
              element={
                <PrivateRouteIsSoucripteur>
                  <PageAdminInstance />
                </PrivateRouteIsSoucripteur>
              }
            />
            {/* routes admin EASYGOUV */}
            <Route
              exact
              path="/admin/easygouv/visualmanagement"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminVisualManagement />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/alaune"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminAlaUne />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/notifications"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminNotifications />
                </PrivateRouteIsAdminProcess>
              }
            />

            <Route
              exact
              path="/admin/easygouv/sous-menus"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminSousMenus />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/orgunits"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminOrgunits />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/engagements"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminEngagements />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/personnes"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminPersonnes />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/personnes/create"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminCreatePersonne />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/droits-administration"
              element={
                <PrivateRouteIsSoucripteur>
                  <PageAdminDroitsAdministration />
                </PrivateRouteIsSoucripteur>
              }
            />
            <Route
              exact
              path="/admin/easygouv/personnes/:id/update"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminUpdatePersonne />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/localisations"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminLocalisations />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/usages"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminUsages />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/marques"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminMarques />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/droits-consultation"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminDroitsConsultation />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/emissions"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminEmission />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/publications"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminPublication />
                </PrivateRouteIsAdminProcess>
              }
            />
            {/* <Route
              exact
              path="/admin/easygouv/offres"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminOffre />
                </PrivateRouteIsAdminProcess>
              }
            /> */}
            <Route
              exact
              path="/admin/easygouv/style"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminStyle />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/processes"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminProcesses />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/processes/:id/view"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminEditView />
                </PrivateRouteIsAdminProcess>
              }
            />
            <Route
              exact
              path="/admin/easygouv/orgunits/pinned"
              element={
                <PrivateRouteIsAdminProcess>
                  <PageAdminPinnedOrgunits />
                </PrivateRouteIsAdminProcess>
              }
            />
            {/* <Route path="*" element={<NotFound />} /> */}
            <Route
              exact
              path="/admin/easygouv/statistiques"
              element={
                <PrivateRouteStatistiquesAccess>
                  <PageAdminStatistiques />
                </PrivateRouteStatistiquesAccess>
              }
            />
          </Routes>
        </BrowserRouter>
      )}
    </>
  );
};

/* permet de vérifier si le gars a bien un email dans le store REDUX pour choisir l'instance et proposer la liste des instances */
function PrivateRouteIsLog({ children }) {
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);
  return ReduxUserEmail ? children : <Navigate to="/" />;
}

/* permet de vérifier si le gars a bien un email et une instance dans le store REDUX pour continuer la navigation */
function PrivateRouteIsLogAndInstance({ children }) {
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);

  return ReduxInstance && ReduxToken ? children : <Navigate to="/" />;
}

/* permet de vérifier si le gars a bien un email dans le store REDUX, une instance et le droits d'accéder à l'admin process de easygouv  */
function PrivateRouteIsAdminProcess({ children }) {
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);

  if (!ReduxUserEmail || !ReduxInstance) return <Navigate to="/" />;

  // si je suis souscripteur
  if (ReduxUserEmail === ReduxInstance.souscripteur) return children;

  // si je suis dans le tableau des adminProcessAccess
  if (ReduxInstance.adminProcessAccess.indexOf(ReduxUserEmail) > -1) return children;

  return <Navigate to="/" />;
}

/* permet de vérifier si le gars a bien un email dans le store REDUX, une instance et le droits d'accéder à l'admin colidee de easygouv  */
function PrivateRouteIsAdminColidee({ children }) {
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);

  if (!ReduxUserEmail || !ReduxInstance) return <Navigate to="/" />;

  // si je suis souscripteur
  if (ReduxUserEmail === ReduxInstance.souscripteur) return children;

  // si je suis dans le tableau des adminProcessAccess
  if (ReduxInstance.adminColideeAccess.indexOf(ReduxUserEmail) > -1) return children;

  return <Navigate to="/" />;
}

/* permet de vérifier si le gars a bien un email dans le store REDUX, une instance et le droits d'accéder aux stats de easygouv  */
function PrivateRouteStatistiquesAccess({ children }) {
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);

  if (!ReduxUserEmail || !ReduxInstance) return <Navigate to="/" />;

  // si je suis souscripteur
  if (ReduxUserEmail === ReduxInstance.souscripteur) return children;

  // si je suis dans le tableau des adminStatAccess
  if (ReduxInstance.adminStatAccess.indexOf(ReduxUserEmail) > -1) return children;

  return <Navigate to="/" />;
}

/* permet de vérifier si le gars est bien souscripteur  */
function PrivateRouteIsSoucripteur({ children }) {
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);

  if (ReduxUserEmail === ReduxInstance.souscripteur) return children;

  return <Navigate to="/" />;
}
export default App;
